var r = /* @__PURE__ */ ((e) => (e[e.Guest = -1] = "Guest", e[e.AnyOwner = 0] = "AnyOwner", e[e.EmailOwner = 1] = "EmailOwner", e[e.AddressOwner = 2] = "AddressOwner", e[e.FullBindedOwner = 3] = "FullBindedOwner", e[e.SuperUser = 4] = "SuperUser", e[e.Restricted = 99] = "Restricted", e))(r || {});
const t = {
  [
    -1
    /* Guest */
  ]: {
    seeMyItem: !1,
    operation: !1,
    inviteUser: !1
  },
  0: {
    seeMyItem: !0,
    operation: !1,
    inviteUser: !1
  },
  1: {
    seeMyItem: !0,
    operation: !1,
    inviteUser: !1
  },
  2: {
    seeMyItem: !0,
    operation: !0,
    inviteUser: !1
  },
  3: {
    seeMyItem: !0,
    operation: !0,
    inviteUser: !1
  },
  4: {
    seeMyItem: !0,
    operation: !0,
    inviteUser: !0
  },
  99: {
    seeMyItem: !1,
    operation: !1,
    inviteUser: !1
  }
};
export {
  t as Right,
  r as Role
};
//# sourceMappingURL=role.js.map
